import { ReactNode, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { cn } from "@/lib/utils.ts";

export default function FoldableSection({
  title,
  onOpen,
  onClose,
  defaultOpen = false,
  closeTitle,
  children,
  borderTop = false,
  borderBottom = true,
  className,
}: {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  closeTitle?: string;
  onOpen?: () => void;
  onClose?: () => void;
  className?: string;
  borderTop?: boolean;
  borderBottom?: boolean;
}) {
  const [showSection, setShowSection] = useState(defaultOpen);

  return (
    <>
      <button
        className={cn(
          classNames(
            "flex px-3 pt-1.5 gap-2 items-center mb-4 justify-between hover:bg-neutral/10 hover:cursor-pointer",
            {
              "border-b border-b-neutral": !showSection && borderBottom,
              "border-t border-t-neutral": borderTop,
            },
          ),
          className,
        )}
        onClick={(e) => {
          e.preventDefault();
          setShowSection(!showSection);
          !showSection && onOpen && onOpen();
          showSection && onClose && onClose();
        }}
      >
        <h4>{showSection && closeTitle ? closeTitle : title}</h4>
        <FontAwesomeIcon
          className="mb-2"
          icon={showSection ? faChevronUp : faChevronDown}
        />
      </button>
      {showSection && <>{children}</>}
    </>
  );
}
